import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqComponent } from './faq.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { FileDownloadComponent } from '../../shared/components/file-download/file-download.component';
import { DsrIconsModule } from '@desyre/icons-angular';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    FaqComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatButtonModule,
    DsrIconsModule,
    MatIconModule,
    RouterModule,
    TranslateModule
  ],
  exports: [
    FaqComponent
  ]
})

export class FaqModule { }